<div class="footer">
  <div>
    <a routerLink="/">Условия использования</a>
  </div>
  <div>
    <a routerLink="/">Контакты</a>
  </div>
  <div>
    <a routerLink="/">О нас</a>
  </div>
</div>
